export default __webpack_public_path__ + "static/media/leftSemiCircle.0bc06a1a.svg";